import React from "react"
import Chart from "react-apexcharts"
import formatNumber from "./formatNumber"

const BarChart = ({ movements }) => {
  const movementsArray = Object.entries(movements)

  const series = movementsArray.map(([name, { monthlyCounts }]) => ({
    name: name.charAt(0).toUpperCase() + name.slice(1),
    data: monthlyCounts.map(({ total }) => total).reverse(),
  }))

  const monthTranslations = {
    January: "Janeiro",
    February: "Fevereiro",
    March: "Março",
    April: "Abril",
    May: "Maio",
    June: "Junho",
    July: "Julho",
    August: "Agosto",
    September: "Setembro",
    October: "Outubro",
    November: "Novembro",
    December: "Dezembro",
  }

  const translateMonth = month => monthTranslations[month] || ""

  const categories = [
    ...new Set(
      movementsArray.flatMap(mov =>
        mov[1].monthlyCounts.map(({ mes }) => translateMonth(mes))
      )
    ),
  ].reverse()

  const options = {
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "75%",
      },
    },
    xaxis: {
      categories: categories,
    },
    yaxis: {
      title: {
        text: "Quantidade",
      },
      labels: {
        formatter: value =>
          new Intl.NumberFormat("pt-BR").format(Math.round(value)),
      },
    },
    title: {
      text: "Comparação entre Movimentações por Mês",
      align: "left",
    },
    tooltip: {
      y: {
        formatter: value => formatNumber(value),
      },
    },
  }

  return <Chart options={options} series={series} type="bar" height={350} />
}

export default BarChart
